import { render } from "./ResultStatIncorrect.vue?vue&type=template&id=fd7bdd2c&scoped=true"
import script from "./ResultStatIncorrect.vue?vue&type=script&lang=js"
export * from "./ResultStatIncorrect.vue?vue&type=script&lang=js"

import "@/css/components/c-result-stat-incorrect.css?vue&type=style&index=0&id=fd7bdd2c&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd7bdd2c"]])

export default __exports__